import { ErrorHandler, Injectable, InjectionToken, Injector } from '@angular/core';

export const ERROR_HANDLERS = new InjectionToken<ErrorHandler[]>('ERROR_HANDLERS');

@Injectable({ providedIn: 'root' })
export class VisionErrorHandler implements ErrorHandler {
  constructor(private readonly _injector: Injector) {}

  public handleError(error: unknown): void {
    const handlers: Array<ErrorHandler> = this._injector.get<ErrorHandler[]>(ERROR_HANDLERS, []);

    handlers.forEach((errorHandler: ErrorHandler) => {
      errorHandler.handleError(error);
    });
  }
}
